import PropTypes from 'prop-types'

function UrlBuilder( props ){
    const { url, buildURL } = props
    return (
            !buildURL ? 
                url
            :
                `${ window.location.protocol }//${ window.location.host }${ url }`
    )
}

UrlBuilder.propTypes = {
    url: PropTypes.string.isRequired,
    buildURL: PropTypes.bool.isRequired
}

export default UrlBuilder